export default {
  nextJob: 'Nächste Charge',
  plannedJobMetricsUnavailable: 'Metriken sind verfügbar, sobald diese Charge gestartet ist.',
  previousJob: 'Vorherige Charge',
  detailsTabs: {
    events: 'Ereignisse',
    images: 'Bilder',
  },
};
